const originalityWeight = 55;
const publicationsWeight = 20;
const suitabillyWeight = 15;
const cooperationWeight = 10;

export const GradesKeys = {
  ORIGINALITY: 1,
  PUBLICATIONS: 2,
  SUITABILLY: 3,
  COOPERATION: 4,
};

export const getGrades = (
  originalityGarde,
  adequacyGarde,
  suitabillyGarde,
  cooperationGarde
) => [
  {
    key: GradesKeys.ORIGINALITY,
    name: "Scientific quality and originality of the proposed approach and methodology",
    weight: originalityWeight,
    grade: ((originalityGarde / originalityWeight) * 100).toFixed(1),
    weightedGrade: originalityGarde,
  },
  {
    key: GradesKeys.PUBLICATIONS,
    name: "Publications and academic record of the PI/PIs",
    weight: publicationsWeight,
    grade: ((adequacyGarde / publicationsWeight) * 100).toFixed(1),
    weightedGrade: adequacyGarde,
  },
  {
    key: GradesKeys.SUITABILLY,
    name: <><b>Collaboration track (2 PIs or more):</b> Feasibility for achieving the goals through the described collaboration between the PIs and mode of cooperation between the teams
    <br/><b>Solo track (1 PI only):</b> Feasibility for achieving the goals during the duration of the grant and feasibility for future cooperation`</>,
    weight: suitabillyWeight,
    grade: ((suitabillyGarde / suitabillyWeight) * 100).toFixed(1),
    weightedGrade: suitabillyGarde,
  },
  {
    key: GradesKeys.COOPERATION,
    name: "Adequacy of the budget and estimated time frame for project",
    weight: cooperationWeight,
    grade: ((cooperationGarde / cooperationWeight) * 100).toFixed(1),
    weightedGrade: cooperationGarde,
  },
];
